/**
 * DevExtreme (esm/__internal/scheduler/appointments/rendering_strategies/m_strategy_week.js)
 * Version: 23.1.5
 * Build date: Wed Aug 30 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import VerticalRenderingStrategy from "./m_strategy_vertical";
class WeekAppointmentRenderingStrategy extends VerticalRenderingStrategy {
    isApplyCompactAppointmentOffset() {
        if (this.isAdaptive && 0 === this._getMaxAppointmentCountPerCellByType()) {
            return false
        }
        return this.supportCompactDropDownAppointments()
    }
}
export default WeekAppointmentRenderingStrategy;
